import {Pipe, PipeTransform} from '@angular/core';
import _ from "lodash";
import moment from "moment";

export function makeDateReadable(date: Date): string {
  return moment(date).format('YYYY-MM-DD');
}

export function makeReadable(original: string): string {
  return _.startCase(_.toLower(original
    .replaceAll("PENDING_INFO", "NEED_INFO")
    .replaceAll("_", " ")
  ))
    .replaceAll("Pdi", "PDI")
    .replaceAll("Dfc", "DFC");
}

@Pipe({
  standalone: true,
  name: 'readable'
})
export class ReadablePipe implements PipeTransform {
  transform(original: string): string {
    return makeReadable(original);
  }
}
